import { Command, Cordova } from 'pos/common';
import { Preconditions, Result } from 'core/infrastructure';
import { Permission, Res } from 'core/api';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		showCardProcessorAdvancedOptions: () => Promise<Result>
	}
}

Command.register('showCardProcessorAdvancedOptions', Preconditions.ensure(Permission.CardProcessor_ShowAdvancedOptions), async (): Promise<Result> => {

	try {
		await Cordova.showCardProcessorAdvancedOptions();
		return Result.ok();
	}
	catch (error: any) {
		await Message.show(Res.Msg.MSG_CORDOVA_CARD_PROCESSOR_ADAVANCED_OPTIONS_FAILED(error.message || error.msg || error));
		return Result.error();
	}

});